import { render, staticRenderFns } from "./publish_button.vue?vue&type=template&id=98d6b89c&"
import script from "./publish_button.vue?vue&type=script&lang=js&"
export * from "./publish_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "publish_button.vue"
export default component.exports